import React, { useEffect, useState } from "react";
import { Grid, Layout, Modal, notification } from "antd";
import SessionController from "../../components/SessionController";
import DefaultLayoutContent from "./Content";
import { useNavigate } from "react-router-dom";
import SimuladoHeader from "./SimuladoHeader";
import SimuladoSidebar from "./SimuladoSidebar";
import {useSimulado} from "../../../core/hooks/useSimulado";
import SimuladoFooter from "./SimuladoFooter";

interface DefaultLayoutProps {
  children: React.ReactNode;
}


function SimuladoLayout(props: DefaultLayoutProps) {
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const {fetchResolucoes, resolucoes, setResolucao, resolucao, finishByUser} = useSimulado();

  const logOut = () => {
    window.localStorage.clear();
    navigate("/"); 
  };

  useEffect(()=>{
    const load = async () =>{
      await fetchResolucoes();
    }
    load();
  },[fetchResolucoes]);  
  
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => setCollapsed(!collapsed);  

  const setSimuladoByIndex = (index: number) => {
    if (index >= 0 && index < resolucoes.length) {
      setResolucao(resolucoes[index]);
    }
  };

  const setSimuladoMoveLeft = () => {
    const index = resolucoes.findIndex(r => r.id === resolucao?.id);
    if (index > 0) {
      setResolucao(resolucoes[index - 1]);
    }
  };

  const setSimuladoMoveRight = () => {
    const index = resolucoes.findIndex(r => r.id === resolucao?.id);
    if (index < resolucoes.length - 1) {
      setResolucao(resolucoes[index + 1]);
    }
  };

  const confirmFinish = (onConfirm: () => void) => {
    Modal.confirm({
      title: 'Deseja finalizar?',
      content: 'Tem certeza que deseja finalizar o simulado?',
      okText: 'Sim',
      cancelText: 'Cancelar',
      okType: 'primary',
      centered: true,
      onOk: onConfirm, // run your function here
    });
  };  

  /*
    Terminar o simulado leva ao RESULTADO — pelo botão "Finalizar" igual a
    quando o tempo acaba.

    ⚠️ Faltava justamente aqui. O fim por TEMPO sempre redirecionou: o
    `TestClock`, ao receber `stop` do websocket, manda para
    `/resultado-simulado/<registered_id>` (ver `components/TestClock`). Já o
    fim pelo BOTÃO só chamava a API e mostrava um toast — o aluno continuava
    em `/simulado-iniciado`, com a prova já encerrada no servidor e as
    questões ainda na tela, sem nada indicando para onde ir.

    O destino e a forma de navegar são os mesmos do `TestClock` de propósito:
    duas maneiras de terminar a mesma prova não podem acabar em telas
    diferentes. `window.location.href` (e não `navigate`) porque é o que
    recarrega o documento — o store de simulado ainda tem em memória as
    resoluções da prova que acabou, e a tela de resultado precisa lê-las
    novamente do servidor, já pontuadas.

    `/home` é só o retorno de emergência de quando não há `registered_id`:
    sem ele não existe resultado para abrir.
  */
  const handleFinish = async () => {
    try {
      await finishByUser();
    } catch (err) {
      // Sem isto a rejeição sobe como unhandled e o dev server do CRA cobre a
      // tela com o overlay vermelho — e, pior, o aluno seria levado ao
      // resultado de uma prova que o servidor não encerrou.
      notification.error({
        message: "Não foi possível finalizar",
        description:
          "O simulado continua aberto. Tente de novo — se persistir, avise a organização.",
      });
      return;
    }

    const registeredId = resolucao?.registered_id;
    window.location.href = registeredId
      ? `/resultado-simulado/${registeredId}`
      : "/home";
  }

  return (
    /*
      `overflow: hidden` com os 100vh, e a rolagem na coluna de conteúdo.

      Sem isso uma questão alta transbordava e era pintada por cima do rodapé:
      medido, o rodapé ficava em y=788 enquanto o conteúdo ia até 1730, e não
      havia scroller nenhum — o `h-[100%]` da view resolvia contra um pai de
      altura indefinida, então crescia em vez de rolar.

      `minHeight: 0` nos dois Layout internos é o que permite encolher abaixo
      do conteúdo; sem ele um filho de flex usa `min-height: auto` e empurra o
      rodapé para fora em vez de rolar. É a mesma correção já aplicada ao
      Default.layout.
    */
    <Layout style={{height: "100vh", overflow: "hidden" }}>
      <SimuladoHeader onToggleSidebar={toggleSidebar} onFinish={() => confirmFinish(handleFinish)}/>
      <Layout id={"PageLayout"} style={{ minHeight: 0 }}>
        <SimuladoSidebar collapsed={collapsed} questions={resolucoes} resolucao={resolucao} onClick={setSimuladoByIndex}/>
        <Layout style={{ minHeight: 0, overflowY: "auto" }}>
          {/*<Breadcrumb />*/}
          <br/>
          <DefaultLayoutContent>{props.children}</DefaultLayoutContent>
        </Layout>
        {!screens.xs && !screens.sm &&(
          <SessionController
            name="Glauber Santos"
            description="Administrador"
            onLogout={logOut}
          />
        )}
      </Layout>
      <SimuladoFooter onClickLeft={setSimuladoMoveLeft} onClickRight={setSimuladoMoveRight}/>
    </Layout>
  );
}

export default SimuladoLayout;
